import * as React from 'react';
import { useContext } from 'react';

import type { ApolloError } from 'apollo-client';

import type { EnterpriseLearningPathPageFieldsFragment } from 'bundles/enterprise-learning-path-description-page/queries/__generated__/EnterpriseLearningPathPageFragments';

type EnterpriseLearningPathContextType =
  | {
      learningPathPage?: EnterpriseLearningPathPageFieldsFragment | null;
      learningPathName?: string;
      isLPDataLoading?: boolean;
      error?: ApolloError;
      collectionId?: string;
    }
  | undefined;

const EnterpriseLearningPathContext = React.createContext<EnterpriseLearningPathContextType>(undefined);

export const useEnterpriseLearningPathPageData = () => {
  const context = useContext(EnterpriseLearningPathContext);

  return context?.learningPathPage;
};

export const useEnterpriseLearningPathName = () => {
  const context = useContext(EnterpriseLearningPathContext);

  return context?.learningPathName ?? context?.learningPathPage?.enterpriseBadge?.name;
};

export const useIsEnterpriseLearningPathDataLoading = () => {
  const context = useContext(EnterpriseLearningPathContext);

  return context?.isLPDataLoading;
};

export const useEnterpriseLearningPathCollectionId = () => {
  const context = useContext(EnterpriseLearningPathContext);

  return context?.collectionId;
};

export const useEnterpriseLearningPathPageError = () => {
  const context = useContext(EnterpriseLearningPathContext);

  return context?.error;
};

export default EnterpriseLearningPathContext;
